<script setup lang="ts">
import { useModuleStore } from '@/stores/moduleStore'
import { storeToRefs } from 'pinia'
import { computed, onMounted, inject } from 'vue'
import { DomainTransKey } from '@/i18n/domainTrans'

const dt = inject(DomainTransKey)!

const moduleStore = useModuleStore()
const { modules, isLoaded, currentModule } = storeToRefs(moduleStore)

const selectedModuleId = computed<string>({
  get: () => currentModule.value ? String(currentModule.value.id) : '',
  set: (id) => { if (id) moduleStore.setCurrentModuleFromId(id) }
})

// Optional: keep as-is (no sorting). If you want deterministic fallback sorting by localized label:
const modulesForSelect = computed(() =>
  modules.value.slice().sort((a, b) =>
    dt.t(a.title, a.title_i18n, a.baseLocale).localeCompare(
      dt.t(b.title, b.title_i18n, b.baseLocale)
    )
  )
)

onMounted(async () => {
  if (!isLoaded.value) await moduleStore.fetchAll(true)
})
</script>

<template>
  <div class="container" v-if="isLoaded">
    <select class="menu" v-model="selectedModuleId">
      <option v-for="module in modulesForSelect" :key="module.id" :value="String(module.id)">
        {{ dt.t(module.title, module.title_i18n, module.baseLocale) }}
      </option>
    </select>
  </div>

  <div class="container" v-else>
    <select class="menu">
      <option selected disabled>{{ $t('common.loading') }} ...</option>
    </select>
  </div>
</template>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
}
.menu {
  border-radius: 8px 0px 8px 0;
  background-color: var(--color-menu);
  border-top: 1px solid var(--color-menu-divider-2);
  border-bottom: 2px solid var(--color-menu-divider);
  color: var(--color-text);
  text-align: center;
}

.menu:hover {
  background-color: var(--color-menu-divider);;
}

.menu.emphasis {
  background-color: var(--color-menu-emp);
  border-top: 1px solid var(--color-menu-emp-divider);
  border-bottom: 2px solid var(--color-menu-emp-divider-2);
  color: var(--color-text);
}

.menu.emphasis:hover {
  background-color: var(--color-menu-emp-divider-2);
}
</style>
